import { makeStyles } from "@material-ui/core";
import { card } from "../../../core/constants";
export default makeStyles((theme) => ({
  card: {
    ...card,
  },
}));
